module.exports = __webpack_public_path__ + "static/media/pedidos.2288aefc.png";